import React from "react";

const Footer = () => {
  return (
    <>
      <div className="bg-do-blue-lighter">
        <div className="flex flex-col lg:flex-row mx-8 gap-y-8 lg:mx-32 py-20 border-b border-gray-400">
          <div className="w-full lg:w-1/5">
            <div className="font-medium text-xl mb-5">Company</div>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              About
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Leadership
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Blog
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Careers
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Customers
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Partners
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Referral Program
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Press
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Legal
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Trust Platform
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Investor Relations
            </a>
          </div>
          <div className="w-full lg:w-1/5">
            <div className="font-medium text-xl mb-5">Products</div>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Products Overview
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Droplets
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Kubernetes
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Managed Databases
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Spaces
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Marketplace
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Load Balancers
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Block Storage
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Tools & Integrations
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              API
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Pricing
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Documentation
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Release Notes
            </a>
          </div>
          <div className="w-full lg:w-1/5">
            <div className="font-medium text-xl mb-5">Community</div>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Tutorials
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Meetups
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Q&A
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Write for DOnations
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Droplets for Demos
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Hatch Startup Program
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Shop Swag
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Research Program
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Currents Research
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Open Source
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Code of Conduct
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Newsletter Signup
            </a>
          </div>
          <div className="w-full lg:w-1/5">
            <div className="font-medium text-xl mb-5">Solutions</div>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Web & Mobile Apps
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Website Hosting
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Game Development
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Streaming
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              VPN
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Startups
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              SaaS Solutions
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Agency & Web Dev Shops
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Managed Cloud Hosting Providers
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Big Data
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Business Solutions
            </a>
          </div>
          <div className="w-full lg:w-1/5">
            <div className="font-medium text-xl mb-5">Contact</div>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Support
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Sales
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Report Abuse
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              System Status
            </a>
            <a
              href="/"
              className="text-gray-600 block mb-2 hover:text-gray-900"
            >
              Share your ideas
            </a>
          </div>
        </div>
      </div>

      <div className="bg-do-blue-lighter">
        <div className="mx-8 lg:mx-32 flex flex-col gap-y-4 lg:flex-row items-center justify-between py-10">
          <div className="flex gap-x-5 items-center">
            <img
              className="w-16 lg:w-10"
              src="/images/digital-ocean.svg"
              alt=""
            />
            <div className="text-gray-500 text-center lg:text-left">
              © 2021 DigitalOcean, LLC. All rights reserved.
            </div>
          </div>
          <div className="flex gap-x-2">
            <a href="/" className="hover:opacity-70">
              <img src="/images/twitch-social-icon.svg" alt="" />
            </a>
            <a href="/" className="hover:opacity-70">
              <img src="/images/twitter-social-icon.svg" alt="" />
            </a>
            <a href="/" className="hover:opacity-70">
              <img src="/images/facebook-social-icon.svg" alt="" />
            </a>
            <a href="/" className="hover:opacity-70">
              <img src="/images/instagram-social-icon.svg" alt="" />
            </a>
            <a href="/" className="hover:opacity-70">
              <img src="/images/youtube-social-icon.svg" alt="" />
            </a>
            <a href="/" className="hover:opacity-70">
              <img src="/images/linkedin-social-icon.svg" alt="" />
            </a>
            <a href="/" className="hover:opacity-70">
              <img src="/images/dev-social-icon.svg" alt="" />
            </a>
            <a href="/" className="hover:opacity-70">
              <img src="/images/glassdoor-social-icon.svg" alt="" />
            </a>
            <a href="/" className="hover:opacity-70">
              <img src="/images/builtin-social-icon.svg" alt="" />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
